/**
 * 一些枚举
 * @filename: package/packages/react-components/src/enum.ts
 * @author: Mr Prince
 * @date: 2022-10-08 11:53:24
 */
export enum Position {
  middle = 'middle',
  top = 'top',
  bottom = 'bottom',
}

